import queryGQL from "@/Apollo/query/homepage/homepage.graphql";
import { HomepageQuery, HomepageQueryVariables } from "@/Apollo/schema";
import { QueryHookOptions, useQuery } from "@apollo/client";

export const useHomepage = (
  options?: QueryHookOptions<HomepageQuery, HomepageQueryVariables>
) => {
  return useQuery(queryGQL, options);
};
